<template>
  <div
    class="modal fade"
    v-bind:id="'ModalEditTabagheBandiAmaliyati-' + getSPerNationalId"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <!-- v-on:mousemove="ModalMove"
    v-on:mouseup="CancelClickModal" -->
    <div 
      class="modal-dialog modal-notify modal-info" 
      role="document"  
    >
      <!--Content-->
      <div 
        class="modal-content text-center"
        v-bind:style="strModalStyle"
      >
        <!--Header-->
        <div 
          class="modal-header d-flex justify-content-between align-items-center"
        >
          <span class="mr-3"></span>
          <p class="heading">ویرایش اطلاعات طبقه بندی عملیاتی</p>
          <i 
            class="fas fa-arrows-alt fa-2x text-white ml-3"
            v-on:mousemove.stop
            v-on:mousedown="MouseClickModal"
            style="cursor: move;"
          ></i>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">

          <p class="h6 mt-2 text-info">{{this.getTitel1}}</p>

          <div class="row">
            <!-- کادر کد طبقه بندی -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="کد طبقه بندی"
                class="form-control text-center"
                v-model="EditListTabagheBandiAmaliyati.SPerNationalId"
                autocomplete="off"
                style="direction: ltr"
                maxlength="8"
                disabled
              />
              <i
                class="
                  fas
                  fa-qrcode fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="کد طبقه بندی"
                style="top: 25%"
              ></i>
            </div>

            <!-- کادر عنوان طبقه بندی -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="عنوان طبقه بندی"
                class="form-control text-center"
                v-model="EditListTabagheBandiAmaliyati.NPerLastName"
                autocomplete="off"
                maxlength="80"
                id="inputNPerLastName"
              />
              <i
                title="عنوان طبقه بندی"
                class="
                  fas
                  fa-edit fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
              ></i>
            </div>

          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center justify-content-between px-4" style="height: 15%">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="EditTabagheBandiAmaliyati()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            {{this.getTitel1}}
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditTabagheBandiAmaliyati',
  props: ['Title1', 'RowTabagheBandiData'],
  data() {
    return {
      // اطلاعات طبقه بندی عملیاتی
      EditListTabagheBandiAmaliyati: {
        NUserCode: 1, // کد کاربر مدیر
        NPerID: 0, // کد یکتا سطر
        SPerNationalId: 0, //  کد طبقه بندی علمیاتی
        NPerTaxNu: "", // خالی
        NPerNationalType: 1, // 1
        NPerType: 4, // کد نوع : 4 ماموریت - 5 برنامه - 6 طرح - 7 خدمت - 8 پروژه
        NPerTaxType: 5, // 5
        NPerName: "ماموریت", // نام نوع : ماموریت - برنامه - طرح - خدمت - پروژه
        NPerLastName: "", // عنوان طبقه بندی عملیاتی
        NPerProvinceCode: 10, // کد استان
        NPerCityCode: 1001000, // کد شهر
        NPerAddress: "", // خالی
        NPerTelCode: "", // خالی
        NPerTel: "", // خالی
        NPerPostcalCode: "", // خالی
        NPerKalaType: 12, // 12
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        SJob: "", // خالی
        SShopName: "", // خالی
        SMobileNu: "", // خالی
        SFaxNu: "", // خالی
        SAccNu: "", // خالی
        SAccCardNu: "", // خالی
        SAccIRNu: "", // خالی
        NAccBank: 0, // 0
        NPerFatherName: "", // خالی
        NYear: "", // سال
        NGroup: 0, // 0
        NPerIDPay: 0, // 0
      },
      isModalHeaderClick: false,
      ModalWidth: 0,
      ModalX: 0,
      strModalStyle: '',
      // کنترل اتصال به سرور
      checkConnectToServer: false,
    };
  },
  mounted() {
    // رویداد نمایش مودال
    // $('#ModalEditTabagheBandiAmaliyati-' + this.getSPerNationalId).on('shown.bs.modal', this.getUserData);      
    // رویداد بسته شدن مودال
    $('#ModalEditTabagheBandiAmaliyati-' + this.getSPerNationalId).on("hidden.bs.modal", this.HideModal);

  },
  computed: {
    // دریافت کد سطر در حال ویرایش
    getSPerNationalId(){
      this.setLocalData(this.RowTabagheBandiData);
      console.log(this.EditListTabagheBandiAmaliyati.SPerNationalId);
      return this.EditListTabagheBandiAmaliyati.SPerNationalId;
    },
    // دریافت عبارت سربرگ
    getTitel1(){
        setTimeout(() => {
            $('#inputNPerLastName').focus();
            $('#inputNPerLastName').select();
        }, 100);
        return this.Title1;
    },
  },
  methods: {
    // انتقال اطلاعات ورودی به مخزن محلی
    setLocalData(value){
      this.EditListTabagheBandiAmaliyati.NUserCode = value.NUserCode; // کد کاربر مدیر
      this.EditListTabagheBandiAmaliyati.NPerID = value.NPerID; // کد یکتا سطر
      this.EditListTabagheBandiAmaliyati.SPerNationalId = value.SPerNationalId; //  کد طبقه بندی علمیاتی
      this.EditListTabagheBandiAmaliyati.NPerTaxNu = value.NPerTaxNu; // خالی
      this.EditListTabagheBandiAmaliyati.NPerNationalType = value.NPerNationalType; // 1
      this.EditListTabagheBandiAmaliyati.NPerType = value.NPerType; // کد نوع : 4 ماموریت - 5 برنامه - 6 طرح - 7 خدمت - 8 پروژه
      this.EditListTabagheBandiAmaliyati.NPerTaxType = value.NPerTaxType; // 5
      this.EditListTabagheBandiAmaliyati.NPerName = value.NPerName; // نام نوع : ماموریت - برنامه - طرح - خدمت - پروژه
      this.EditListTabagheBandiAmaliyati.NPerLastName = value.NPerLastName; // عنوان طبقه بندی عملیاتی
      this.EditListTabagheBandiAmaliyati.NPerProvinceCode = value.NPerProvinceCode; // کد استان
      this.EditListTabagheBandiAmaliyati.NPerCityCode = value.NPerCityCode; // کد شهر
      this.EditListTabagheBandiAmaliyati.NPerAddress = value.NPerAddress; // خالی
      this.EditListTabagheBandiAmaliyati.NPerTelCode = value.NPerTelCode; // خالی
      this.EditListTabagheBandiAmaliyati.NPerTel = value.NPerTel; // خالی
      this.EditListTabagheBandiAmaliyati.NPerPostcalCode = value.NPerPostcalCode; // خالی
      this.EditListTabagheBandiAmaliyati.NPerKalaType = value.NPerKalaType; // 12
      this.EditListTabagheBandiAmaliyati.SDate = value.SDate; // تاریخ ثبت
      this.EditListTabagheBandiAmaliyati.DTime = value.DTime; // ساعت ثبت
      this.EditListTabagheBandiAmaliyati.SJob = value.SJob; // خالی
      this.EditListTabagheBandiAmaliyati.SShopName = value.SShopName; // خالی
      this.EditListTabagheBandiAmaliyati.SMobileNu = value.SMobileNu; // خالی
      this.EditListTabagheBandiAmaliyati.SFaxNu = value.SFaxNu; // خالی
      this.EditListTabagheBandiAmaliyati.SAccNu = value.SAccNu; // خالی
      this.EditListTabagheBandiAmaliyati.SAccCardNu = value.SAccCardNu; // خالی
      this.EditListTabagheBandiAmaliyati.SAccIRNu = value.SAccIRNu; // خالی
      this.EditListTabagheBandiAmaliyati.NAccBank = value.NAccBank; // 0
      this.EditListTabagheBandiAmaliyati.NPerFatherName = value.NPerFatherName; // خالی
      this.EditListTabagheBandiAmaliyati.NYear = value.NYear; // سال
      this.EditListTabagheBandiAmaliyati.NGroup = value.NGroup; // 0
      this.EditListTabagheBandiAmaliyati.NPerIDPay = value.NPerIDPay; // 0
    },
    // رویداد بسته شدن مودال
    HideModal(){
      this.isModalHeaderClick = false;
    },
    CancelClickModal(){
      this.isModalHeaderClick = false;
    },
    // رویداد حرکت مودال
    ModalMove(event){
      if(this.isModalHeaderClick == true){
        let strStyle = 'left:' + (event.clientX - this.ModalWidth + this.ModalX) + 'px; top:' + (event.clientY - 50) + 'px;';
        this.strModalStyle = strStyle;
      }
    },
    // رویداد کلیک بر روی سربرگ مودال
    MouseClickModal(event){
      this.ModalX = event.target.offsetLeft;
      this.ModalWidth = event.target.parentElement.clientWidth;
      this.isModalHeaderClick = !this.isModalHeaderClick;
    },
    // ذخیره تغییرات حساب کاربری
    async EditTabagheBandiAmaliyati() {
        // آیا کد طبقه بندی مقدار دهی شده است ؟
        if (this.EditListTabagheBandiAmaliyati.SPerNationalId != "") {
          // آیا نام طبقه بندی ثبت شده است ؟
          if (this.EditListTabagheBandiAmaliyati.NPerLastName != "") {
            // اعلام اتصال به سرور
            this.checkConnectToServer = true;
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // ثبت سرفصل حساب جدید در سرور
            await this.$store.dispatch("EditTabagheBandiAmaliyatiToServer", {
              TabagheBandiAmaliyatiData: this.EditListTabagheBandiAmaliyati,
              token: token,
            });
            // بستن مودال ثبت سرفصل حساب جدید
            $("#ModalEditTabagheBandiAmaliyati-" + this.getSPerNationalId).modal("hide");
            // اعلام اعمال تغییرات به والد
            this.$emit("HideModalEditTabagheBandi");
          } else {
            // ثبت نام حساب الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج نام حساب : درج نام حساب الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت کد حساب الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج کد حساب : درج کد حساب الزامی است !",
            timeOut: 2500,
          });
        }
        // لغو اعلام اتصال به سرور
        this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 10%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTabagheBandiAmaliyati/Components/EditTabagheBandiAmaliyati.vue